export default {"src":"/_next/static/media/arr_icon_active.c493c8ec.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};